var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "../Caption";
import Card from "../Card";
import Heading from "../Heading";
import React from 'react';
import { css, mq, styled, uiAssets } from "../../utils";
var StyledCard = styled(Card)(function (_a) {
    var color = _a.color, bgColor = _a.bgColor, colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    text-align: center;\n\n    && {\n      padding: 1.5rem;\n\n      p,\n      h1 {\n        color: ", ";\n      }\n    }\n  "], ["\n    background-color: ", ";\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    text-align: center;\n\n    && {\n      padding: 1.5rem;\n\n      p,\n      h1 {\n        color: ", ";\n      }\n    }\n  "])), bgColor || colors.pink, uiAssets('/bubble-background.svg'), color || colors.white);
}, mq({
    margin: [null, null, '2rem 0'],
}));
var BubbleBanner = function (_a) {
    var title = _a.title, description = _a.description, colors = __rest(_a, ["title", "description"]);
    return (React.createElement(StyledCard, __assign({ "data-component": "BubbleBanner" }, colors),
        React.createElement(Heading.Heading1, null, title),
        description && React.createElement(Caption, { align: "center" }, description)));
};
export default BubbleBanner;
var templateObject_1;
//# sourceMappingURL=BubbleBanner.js.map